module.exports = __webpack_public_path__ + "static/media/MuseoSlab-500.1b67e3c1.woff2";